/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "ReplyListContainer_viewer";
};
export type ReplyListContainer_viewer$data = ReplyListContainer_viewer;
export type ReplyListContainer_viewer$key = {
    readonly " $data"?: ReplyListContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'd51d0881d67fc4f4c9cbada8b991abee';
export default node;
